<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23"  stroke="#055862" fill="none" stroke-linecap="square" stroke-width="2" xmlns:v="https://vecta.io/nano"><path d="M21.5 1.5l-19 20"/><path d="M2 2l20 19"/></svg>
</template>